$( document ).ajaxError(function( event, jqxhr, settings, thrownError ) {
  if(jqxhr.status == 401) {
    location.reload();
  }
  if(jqxhr.status == 403) {
    window.location = "/";
  }
});
